export enum VerificationStatus {
    NotRequired = 0,
    Pending = 1,
    Failed = 2,
    Manual = 3,
    Verified = 4,
    PartialVerified = 5,
};